import { createReducer } from '@reduxjs/toolkit';

import printZebraFile, { clearZebraPrintFile } from '../../thunks/zebraPrinter/printZebraFile';

const initialState = {
  loading: false,
  data: null,
  error: false,
};

const postPrintZebraFileReducer = createReducer(initialState, {
  [printZebraFile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [printZebraFile.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [printZebraFile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  }),
  [clearZebraPrintFile]: () => initialState
});

export default postPrintZebraFileReducer;
